// extracted by mini-css-extract-plugin
export default {"wrapper":"TextEditor_wrapper__96gBe"};